//import swup from '../main.js';

export function filterShowHide()
{
	console.log('filter function');
	$('.filter-trigger').click(function ()
	{
		let parent = $(this).parent();
		let body = parent.find('.category-filter-list');

		if ($(this).hasClass('active'))
		{
			$(this).removeClass('active');
			body.slideUp(400);
		}
		else
		{
			$(this).addClass('active');
			body.slideDown(400);
		}
	});
}

export function selectRouter()
{
	$('.mobile-filter').on('change', function ()
	{
		let route = $(this).val();
		window.location.href = route;
	});
}

export function loadPosts()
{
	let body = $('body');
	let paged = 1;

	let setupRequest = () =>
	{
		let input = $('.page-input');

		let max = input.attr('data-max');
		let cur = input.attr('data-cur');
		let term = 	$('.load-more').attr('data-tax');

		// Colelction already running
		if ( body.hasClass('loading') || input.length <= 0 )
		{
			return;
		}

		// End of collection
		if (cur >= max)
		{
			return;
		}

		let loadMore = cur >= max ? false : true;


		fetchPosts(paged, loadMore, cur, max, input, term);
	}

	$('.load-more').on('click', setupRequest);
}

function fetchPosts(paged, loadMore, cur, max, input, term)
{
	let container = $('.res-container');
	let body = $('body');
	let button = $('.load-more');

	if (body.hasClass('loading'))
	{
		return;
	}

	if (loadMore)
	{
		paged = Number(cur) + 1;
		input.attr('data-cur', paged);
	}
	if(!loadMore || paged >= max)
	{
		button.addClass('disabled');
	}

	body.addClass('loading');

	let data = {
		action: 'run_search',
		paged: paged,
		category: term,
		load_more: loadMore,
	};

	var curScrollPos = $(window).scrollTop();

	$.post(Ajax.url, data, function (res)
	{
		let cleanRes = JSON.parse(res);
		container.append(cleanRes.posts);
		$(window).scrollTop(curScrollPos);

		$('.news-card').each(function (i) {
			let _this = $(this);
			let delay = 200;

			if (i > 4 && i <= 8)
			{
				delay = 400;
			}
			else if (i > 8)
			{
				delay = 600;
			}

			setTimeout( () =>
			{
				_this.removeClass('loading-in');
			}, delay );
		})

		setTimeout( () =>
		{
			body.removeClass('loading');
		}, 600 );
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/collection.js